const normalizeToUtc = (input: string) => {
  if (/[+-]\d{2}:\d{2}$/.test(input))
    return input.replace(/\.(\d{3})\d*/, '.$1');
  if (input.endsWith('Z')) return input.replace(/\.(\d{3})\d*/, '.$1');
  if (input.length === 19) return input + 'Z'; // yyyy-MM-ddTHH:mm:ss

  return input + 'Z';
};

export const formatDate = (date?: string | null) => {
  if (!date) return '';
  if (typeof date !== 'string') return `${date}`;

  if (date.length === 19) {
    return date.replace('T', ' ');
  }

  const normalizedDate = normalizeToUtc(date);
  const parsedDate = new Date(normalizedDate);

  if (isNaN(parsedDate.getTime())) return '';
  return parsedDate.toLocaleString();
};
